import React from 'react';
import { ListingLinkMore } from '@redturtle/volto-io-studio/components/Blocks';

const Bottom = ({ data }) => {
  return <ListingLinkMore {...data} />;
};

export default Bottom;
